import ProductDraftsModal from './ProductDraftsModal'

export default ProductDraftsModal
